export class DocumentMetadata {
    public dateOpened: any;
    public id: string;
    public type: string;
    public lang: string;
    public route: string;

    constructor(id: string, type: string, lang: string) {
        this.dateOpened = new Date();
        this.id = id;
        this.type = type;
        this.lang = lang;
        this.route = '';
    }

    
}